(function($) {
	
	//'use strict';
	var win = $(window);
    var applyFilterBtn;
    
    var filterSearch = function() {
        var t = $(this);
        var ctn = t.parent('.nouvelles-liste-filtres');
        var selectedItem = $('.dropdown-select-pannel-item.selected', ctn);
        var path = window.location.pathname;

        if (selectedItem.data('type') == 'category') {
            path += '?categoryId='+selectedItem.data('value');
            window.location.href = path;
        }
        else {
            path += '?chapitreId='+selectedItem.data('value');
            window.location.href = path;
        }
    };

	win.load(function () {
        applyFilterBtn = $('.blog-filter-btn');

        applyFilterBtn.on("click", filterSearch);
	});
	
	
})(jQuery);